function searchComponent() {
  return {
    query: '',
    page: 1,
    products: [],
    pages: [],
    recipes: [],
    collections: [],
    totalPages: 0,
    totalRecipePages: 0,
    itemsPerPage: 36,
    showPagination: true,
    totalProductHits: 0,
    totalRecipeHits: 0,
    excludedHandles: [
      'bundle',
      'bundle-dummy',
      'gratisbuch',
      'dein-gratisprodukt',
      'dein-gratistee',
      'reisekraut'
    ],
    facetDistribution: { product: { tags: {} }, recipe: { tags: {} } },
    selectedFacets: [],
    selectedFacetCategories: {
      sort: ['Relevanz'],
      geeignet_zum: [],
      passt_zu: [],
      ernaehrung: [],
      landestypisch: [],
      ernaehrungsweise: [],
      art: [],
      herkunft: [],
      zubereitungsweise: [],
    },
    availableFacetCategories: {
      product: {
        sort: {
          "label": "Sortieren nach",
          "alt_label": "Sortieren nach",
          "values": [
            {
              label: "Relevanz",
              value: "[monthly_sales:desc]"
            },
            {
              label: "Beste Bewertung",
              value: "[rating:desc]"
            },
            {
              label: "Neuheiten zuerst",
              value: "[created_at:desc]"
            },
            {
              label: "Name A-Z",
              value: "[title:asc]"
            },
            {
              label: "Name Z-A",
              value: "[title:desc]"
            },
            {
              label: "Preis absteigend",
              value: "[price:desc]"
            },
            {
              label: "Preis aufsteigend",
              value: "[price:asc]"
            },
          ],
        },
        geeignet_zum: {
          "label": "Geeignet zum_",
          "alt_label": "Geeignet zum",
          "values": ['Kochen', 'Backen', 'Grillen', 'Rubs & Finisher', 'Dippen'],
        },
        passt_zu: {
          "label": "Passt zu_",
          "alt_label": "Passt zu",
          "values": ['Rind', 'Schwein', 'Geflügel', 'Wild', 'Fisch / Meeresfrüchte', 'Lamm', 'Tofu', 'Käse / Milch- u. Eierprodukte', 'Gemüse', 'Obst', 'Pasta', 'Reis', 'Kartoffel', 'Salat', 'Suppe / Eintöpfe', 'Sauce', 'Brot', 'Gebäck'],
        },
        ernaehrung: {
          "label": "Ernährung_",
          "alt_label": "Ernährung",
          "values": ['Bio', 'Vegan', 'Vegetarisch'],
        },
        // could be "landestypisch_für" and then in alpine loop through the object and replace the label into the key
        landestypisch: {
          "label": "Landestypisch für_",
          "alt_label": "Länderküche",
          "values": ['Deutschland', 'Spanien', 'Italien', 'Indien', 'Mexiko', 'Griechenland', 'Türkei', 'China', 'Thailand', 'Marokko'],
        },
      },
      recipe:{
        sort: {
          "label": "Sortieren nach",
          "alt_label": "Sortieren nach",
          "values": [
            {
              label: "Relevanz",
              value: "[monthly_sales:desc]"
            },
            {
              label: "Beste Bewertung",
              value: "[rating:desc]"
            },
            {
              label: "Neuheiten zuerst",
              value: "[created_at:desc]"
            },
            {
              label: "Name A-Z",
              value: "[title:asc]"
            },
            {
              label: "Name Z-A",
              value: "[title:desc]"
            },
            {
              label: "Gesamtaufwand absteigend",
              value: "[total_time:desc]"
            },
            {
              label: "Gesamtaufwand aufsteigend",
              value: "[total_time:asc]"
            },
          ],
        },
        ernaehrungsweise: {
          "label": "Ernährungsweise",
          "alt_label": "Ernährungsweise",
          "values": ['Fleisch', 'Günstig', 'lowcarb', 'Pescetarisch', 'Vegan', 'Vegetarisch'],
        },
        art: {
          "label": "Art",
          "alt_label": "Art",
          "values": ['Curry', 'Kartoffeln', 'Pasta', 'Reis', 'Salat', 'Snack', 'Suppe 🥣', 'Weihnachten', 'Frühstück'],
        },
        herkunft: {
          "label": "Herkunft",
          "alt_label": "Herkunft",
          "values": ['Asiatisch', 'Amerikanisch', 'Arabisch', 'Afrikanisch', 'Orientalisch', 'Deutsch', 'Spanisch', 'Italienisch', 'Indisch', 'Mexikanisch', 'Griechisch', 'Türkisch', 'Chinesisch', 'Marokkanisch', 'Französisch', 'Japanisch'],
        },
        zubereitungsweise: {
          "label": "Zubereitungsweise",
          "alt_label": "Zubereitungsweise",
          "values": ['Kochen', 'Backen', 'Grillen', 'Braten', 'Heißluftfritteuse'],
        },
      }
      
    },
    type: 'product',
    filterType: 'all',
    width: window.innerWidth,
    sort: "[monthly_sales:desc]",
    open: false,
    debounceTimer: 0,
    minQueryLength: Alpine.store('meilimetaNew').enabled ? !Alpine.store('meiliNewProductsVisible').enabled ? 3 : 0 : 3,

    get combined() {
      const combinedArray = [
        ...this.pages.map(page => ({ ...page, type: 'page' })),
        ...this.recipes.map(recipe => ({ ...recipe, type: 'recipe' }))
      ];
      return combinedArray;
    },

    async search(initOrNextPage = false) {
      if (this.query.length < this.minQueryLength && !Alpine.store('meiliNewProductsVisible').enabled) return;
      if (this.sort === "[monthly_sales:desc]" && Alpine.store('meilimetaNew').enabled) {
        this.resetSorting();
        if (this.query.length > 0) {
          this.sort = "";
        }
      }

      const meilisearchElement = document.querySelector('.meilisearch');

      let url = `https://suche.ankerkraut.de/search?q=${encodeURIComponent(this.query)}&page=${this.page}`;

      if ((this.type === 'product' || this.type === 'recipe') && this.selectedFacets.length > 0) {
        url += `&facets=${this.selectedFacets}`;
      }
      if ((this.type === 'product' || this.type === 'recipe') && Alpine.store('meilimetaNew').enabled && this.sort) {
        url += `&sort=${this.sort}`;
      }
      try {
        const response = await fetch(url).then((res) => res.json());
        if (this.type === 'product') {
          this.products = this.filterProducts(response.products || []);
          this.pages = [];
          this.recipes = [];
        } else if (this.type === 'recipe') {
          this.recipes = (response.recipes || []).filter(recipe => recipe.blog_handle === "rezepte");
          this.pages = [];
          this.products = [];
        } else if (this.type === 'page') {
          this.pages = (response.pages || []).concat((response.recipes || []).filter(recipe => recipe.blog_handle === "magazin"));
          this.recipes = [];
          this.products = [];
        }

        this.collections = response.collections || [];
        this.totalProductHits = response.total_product_hits || 0;
        this.totalRecipeHits = response.total_recipe_hits || 0;
        this.totalPages = Math.ceil(response.total_product_hits / response.hits_per_page);
        this.totalRecipePages = Math.ceil(response.total_recipe_hits / response.hits_per_page);
        this.facetDistribution = response.facet_distribution || [];

        if (this.type !== 'product' && this.type !== 'recipe') {
          this.selectedFacets = [];
          this.priceMin = 0;
          this.priceMax = 10;
        }
        if (
          this.products.length ||
          this.pages.length ||
          this.recipes.length ||
          this.collections.length
        ) {
          if (!initOrNextPage) {
            meilisearchElement.classList.add('has-results');
          }
        } else {
          meilisearchElement.classList.remove('has-results');
        }
        checkHasResults();
        Alpine.nextTick(() => { });
      } catch (error) {
        console.error('Error fetching search results:', error);
        meilisearchElement.classList.remove('has-results');
      }
      this.debounceTimer = 0;
    },

    stripHtmlAndTruncate(html, maxLength) {
      const div = document.createElement('div');
      div.innerHTML = html;
      let text = div.textContent || div.innerText || '';
      if (maxLength && text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
      }
      return text;
    },

    filterProducts(products) {
      return products.filter(product => !this.excludedHandles.includes(product.handle));
    },

    toggleFacet(event, facet, category) {
      while (this.debounceTimer !== 0) {
        if (facetDistribution[type].tags[(this.type === 'product' ? availableFacetCategories[this.type][category].label + facet : facet)] == 0) {
          event.preventDefault();
          return;
        }
      }
      if (!Alpine.store('meiliFilterWithCheckboxes').enabled) {
        event.preventDefault();
        if (event.target.classList.contains("filter-btn")) {
          event.target.classList.toggle('isSelected');
        } else {
          event.target.parentElement.classList.toggle('isSelected');
        }
      }
      const index = this.selectedFacets.indexOf(encodeURIComponent(facet));
      if (index > -1) {
        this.selectedFacets.splice(index, 1);
        const categoryIndex = this.selectedFacetCategories[category].indexOf(facet.split('_').at(-1));
        if (categoryIndex > -1) {
          this.selectedFacetCategories[category].splice(categoryIndex, 1);
        }
      } else {
        this.selectedFacets.push(encodeURIComponent(facet));
        this.selectedFacetCategories[category].push(facet.split('_').at(-1));
      }
      this.debounceTimer = 300;
      this.search();
    },

    debounce_facet() {
      this.debounceTimer = 100;
      setTimeout(() => {
        this.debounceTimer = 0;
      }, 150);
    },

    toggleMobileFilter(event) {
      event.preventDefault();
      const filterButton = document.getElementById('filter-button-mobile-new text');
      const filterCategoryMobile = document.querySelector('.filterCategory-mobile-new');
      filterButton.classList.toggle('isOpen');
      filterCategoryMobile.classList.toggle('isOpen');
      this.filterType = 'all';
    },

    toggleChat(event) {
      event.preventDefault();
      this.type = "chatbot";
    },

    closeMobileFilter(event) {
      event.preventDefault();
      const filterCategoryMobile = document.querySelector('.filterCategory-mobile-new');
      const filterButton = document.getElementById('filter-button-mobile');
      const filterChips = document.querySelector('.filterChipContainer');
      const filterOverlay = document.querySelector('.FilterOverlay');
      filterCategoryMobile.classList.remove('isOpen');
      filterButton.classList.remove('isOpen');
      filterChips.style.display = 'flex';
      filterOverlay.classList.remove("is-visible");
      this.filterType = 'all';
    },

    changeFilter(event = null, filterType) {
      if (event != null) event.preventDefault();
      this.filterType = filterType;
      if (window.innerWidth > 768 && !Alpine.store('meiliNewProductsVisible').enabled && Alpine.store('meilimetaNew').enabled) {
        currentResultHeader = Alpine.store('meiliheader').type === 'product' ? document.querySelector('.result-header') : document.querySelector('.result-header.recipe');
        const filterChips = document.querySelector('.filterChipContainer');
        currentResultHeader.insertAdjacentElement("afterbegin", filterChips);
      }
    },

    viewAllResults(event) {
      if (event) event.preventDefault();
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=all`;
    },

    viewAllProducts(event) {
      if (event) event.preventDefault();
      const meilisearchElement = document.querySelector('.meilisearch');
      this.open = false;
      this.changeVisibility();
      meilisearchElement.classList.remove('has-results');
      let facetsPart = '';
      let sortsPart = '';
      if (this.selectedFacets.length > 0) {
        facetsPart = `&facets=[${this.selectedFacets.join(',')}]`;
      }
      if (this.sort) {
        sortsPart += `&sort=${this.sort}`;
      }
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=product${facetsPart}${sortsPart}`;
    },


    viewAll(event) {
      if (event) event.preventDefault();
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=product`;
    },

    viewAllPages(event) {
      if (event) event.preventDefault();
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=page`;
    },

    viewAllArticles(event) {
      if (event) event.preventDefault();
      const meilisearchElement = document.querySelector('.meilisearch');
      this.open = false;
      this.changeVisibility();
      meilisearchElement.classList.remove('has-results');
      let facetsPart = '';
      let sortsPart = '';
      if (this.selectedFacets.length > 0) {
        facetsPart = `&facets=[${this.selectedFacets.join(',')}]`;
      }
      if (this.sort) {
        sortsPart += `&sort=${this.sort}`;
      }
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=recipe${facetsPart}${sortsPart}`;
    },

    goToPage(pageNumber) {
      this.page = pageNumber;
      this.search(true);
    },

    nextPage() {
      if (this.type === 'product' && this.page < this.totalPages) {
        this.goToPage(this.page + 1);
      }
      if (this.type === 'recipe' && this.page < this.totalRecipePages) {
        this.goToPage(this.page + 1);
      }
    },

    previousPage() {
      if (this.type === 'product' && this.page > 1) {
        this.goToPage(this.page - 1);
      }
      if (this.type === 'recipe' && this.page > 1) {
        this.goToPage(this.page - 1);
      }
    },

    resetFacets() {
      this.selectedFacets = [];
      this.selectedFacetCategories = {
        sort: ['Relevanz'],
        geeignet_zum: [],
        passt_zu: [],
        ernaehrung: [],
        landestypisch: [],
        ernaehrungsweise: [],
        art: [],
        herkunft: [],
        zubereitungsweise: [],
    },
      this.search();
      if (Alpine.store('meilimetaNew').enabled) {
        if (Alpine.store('meiliFilterWithCheckboxes').enabled) {
          let filterCheckboxes = document.querySelectorAll('.filter-checkbox');
          filterCheckboxes.forEach(checkbox => { checkbox.checked = false; });
        } else {
          let filterButtons = document.querySelectorAll('.filter-btn');
          filterButtons.forEach(button => button.classList.remove('isSelected'));
        }
      }
    },

    resetSorting() {
      this.selectedFacetCategories.sort = ['Relevanz'];
      const sortRadios = document.getElementsByName('sortFilterContainer');
      sortRadios.forEach(element => {
        const selection = element.querySelectorAll('input[type="radio"]');
        selection.forEach(radio => {
          if (radio.id === 'Relevanz') {
            radio.setAttribute('checked', 'true');
            radio.checked = true;
          } else {
            radio.setAttribute('checked', 'false');
            radio.removeAttribute('checked');
            radio.checked = false;
          }
        });
      });
    },

    changeTypeBubble(event, newType) {
      event.preventDefault();
      if (newType === "recipe") {
        this.sort = "";
      } else {
        this.sort = "[monthly_sales:desc]";
      }
      this.resetSorting();
      this.type = newType;
      this.changeFilter(null, "all");
      this.resetFacets();
      this.search();
    },

    handleResize() {
      if (window.pathname === '/search') return;
      const meilisearchElement = document.querySelector('.meilisearch');
      this.width = window.innerWidth;
      this.open = meilisearchElement.classList.contains('has-results') && (meilisearchElement.getAttribute('aria-expanded') === 'true' || meilisearchElement.getAttribute('aria-hidden') === 'false' || this.width <= 768) || (meilisearchElement.getAttribute('aria-hidden') === 'false' && !Alpine.store('meiliNewProductsVisible').enabled);
      this.changeVisibility();
    },

    changeVisibility() {
      if (this.width > 768) {
        meilisearchElement.setAttribute('aria-expanded', null);
        meilisearchElement.removeAttribute('aria-expanded');
        meilisearchElement.setAttribute('aria-hidden', !this.open);
      } else {
        meilisearchElement.setAttribute('aria-expanded', this.open);
        meilisearchElement.setAttribute('aria-hidden', null);
        meilisearchElement.removeAttribute('aria-hidden');
      }
    },

    initialize() {
      const params = new URLSearchParams(window.location.search);
      this.query = params.get('query') || '';
      this.type = params.get('type') || 'product';
      const facetsParam = params.get('facets');
      const sortParam = params.get('sort');
      if (facetsParam) {
        let stripped = facetsParam.replace(/^\[|\]$/g, '');
        this.selectedFacets = stripped ? stripped.split(',') : [];
      }
      if (sortParam) {
        this.sort = sortParam;
      }
      if (this.query || Alpine.store('meilimetaNew').enabled) {
        this.search(true);
      }
    }

  }
}

document.addEventListener('alpine:init', () => {
  Alpine.store('meilimeta', { enabled: true });
  Alpine.store('meilimetaNew', { enabled: false });
  Alpine.store('meiliOldFilter', { enabled: true });
  Alpine.store('meiliFilterWithCheckboxes', { enabled: false });
  Alpine.store('meiliNewProductsVisible', { enabled: false });
  if (window.location.pathname === '/search') {
    Alpine.store('meilibody', searchComponent());
    Alpine.store('meilibody').initialize();
  }
  Alpine.store('meiliheader', searchComponent());
  Alpine.store('meiliblog', searchComponent());
  Alpine.store('meiliblog').type = 'recipe';
});

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    }
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
}

const meilisearchElement = document.querySelector('.meilisearch');
let resultsFlex = document.querySelector('.resultsFlex');
const checkHasResults = debounce(() => {
  if (!resultsFlex) {
    resultsFlex = document.querySelector('.resultsFlex.new');
  }
  if (meilisearchElement.classList.contains('has-results')) {
    resultsFlex.classList.add('isOpen');
  }
}, 700);
document.querySelector('.meiliInputHeader').addEventListener('input', checkHasResults);

async function checkMeilisearchHealth() {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 2000);
    const response = await fetch('https://suche.ankerkraut.de/health', { signal: controller.signal });
    clearTimeout(timeoutId);
    if (!response.ok) {
      throw new Error('Meilisearch health check failed');
    }
    const healthStatus = await response.text();
    if (healthStatus !== 'OK') {
      throw new Error('Meilisearch is not available');
    }
  } catch (error) {
    console.error('Meilisearch health check failed:', error);
    Alpine.store('meilimeta', { enabled: false });
  }
}
checkMeilisearchHealth();

